import {printoutPalette} from "../../core/printoutPalette";

export const imageBlockSx = {
    "& .printout-image-block": {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        // Keep each image intact across native print pagination.
        "@media print": {
            breakInside: "avoid",
            pageBreakInside: "avoid",
        },
    },
    '& .printout-image-block[data-printout-image-alignment="left"]': {
        justifyContent: "flex-start",
    },
    '& .printout-image-block[data-printout-image-alignment="right"]': {
        justifyContent: "flex-end",
    },
    "& .printout-image-frame": {
        maxWidth: "100%",
        overflow: "hidden",
        printColorAdjust: "exact",
        WebkitPrintColorAdjust: "exact",
    },
    "& .printout-image-frame img": {
        display: "block",
        height: "100%",
        width: "100%",
    },
    "& .printout-image-frame-empty": {
        alignItems: "center",
        border: `1px dashed ${printoutPalette.border}`,
        borderRadius: "4px",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
    },
    "& .printout-image-placeholder": {
        alignItems: "center",
        color: printoutPalette.mutedText,
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        px: 1,
        textAlign: "center",
    },
    "& .printout-image-placeholder-size": {
        fontSize: "11px",
        fontWeight: 700,
    },
    "& .printout-image-placeholder-hint": {
        fontSize: "10px",
    },
};
